import DateFnsUtils from '@date-io/date-fns';
import theme from '@ifca-root/react-component/src/assets/theme';
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents';
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList';
import { DynamicFooter } from 'components/Footer/DynamicFooter';
import DynamicSubHeader from '@ifca-root/react-component/src/components/Header/DynamicSubHeader';
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader';
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper';
import {
	StyledMenu,
	StyledMenuItem,
} from '@ifca-root/react-component/src/components/others/Menu';
import {
	CardActions,
	ListItemText,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	TextField,
	useMediaQuery,
} from '@material-ui/core';
import ShareIcon from '@material-ui/icons/Share';
import {
	KeyboardDatePicker,
	MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import AppContext from 'containers/App/Store/AppContext';
import {
	useCreateReceiptAttachmentMutation,
	useEmailSendMutation,
	useGetBizInsightOutletQuery,
	useGetFamilyQuery,
	useGetMajorQuery,
	useGetMealPeriodQuery,
	useGetShareAttachmentMutation,
	useGetSlowMovingMenuItemAnalysisLazyQuery,
} from 'generated/graphql';
import { formatDate } from 'helpers/hooks/formatDate';
import { useMenuOption } from 'helpers/hooks/useMenuOption';
import { amtStr } from 'helpers/numFormatter';
import * as htmlToImage from 'html-to-image';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import ShareDialog, { EmailDialog, PhoneNumDialog } from '../../../../../components/Dialog/ShareDialog';
import { useSnackBar } from 'helpers/hooks/useSnackBar';
import ReactDOMServer from 'react-dom/server';
import SnackBarMsg from '@ifca-root/react-component/src/components/SnackBar/SnackBarMsg';

interface SlowMovingProps {
	major: string;
	family: string;
	mealPeriod: string;
	startDate: Date;
	endDate: Date;
}

export const SlowMovingAnalysis = (props: any) => {
	const history = useHistory();
	const user = JSON.parse(localStorage.getItem('loggedInUser'));
	const latestOutlet = localStorage.getItem('latestOutlet');

	const { anchorEl, menu, handleClick, handleClose } = useMenuOption();

	const { globalState } = useContext(AppContext as any);
	const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
		defaultMatches: true,
	});

	const { register, control, handleSubmit, errors, watch, setValue } = useForm<
		SlowMovingProps
	>({
		defaultValues: {},
	});

	const date = new Date();
	const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
	const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

	//selectedStartDate
	const [selectedStartDate, setSelectedStartDate] = React.useState<Date | null>(
		firstDay,
	);
	const handleStartDateChange = (date: Date | null) => {
		setSelectedStartDate(date);
	};

	//selectedEndDate
	const [selectedEndDate, setSelectedEndDate] = React.useState<Date | null>(
		lastDay,
	);
	const handleEndDateChange = (date: Date | null) => {
		setSelectedEndDate(date);
	};

	//getOutlet
	const {
		data: { getOutlet } = { getOutlet: [] },
		called: getOutletCalled,
		loading: getOutletLoading,
	} = useGetBizInsightOutletQuery({
		fetchPolicy: 'network-only',
	});

	//selectedOutlet
	const [selectedOutlet, setSelectedOutlet] = useState(null);
	useEffect(() => {
		setSelectedOutlet(
			getOutlet?.filter(outlet => outlet?.ID === latestOutlet)[0],
		);
	}, [getOutlet]);

	//getMajor
	const {
		data: { getMajor } = { getMajor: [] },
		called: majorCalled,
		loading: majorLoading,
	} = useGetMajorQuery({
		fetchPolicy: 'network-only',
		variables: { outletID: selectedOutlet?.ID },
	});

	//selectedMajor
	const [selectedMajor, setSelectedMajor] = useState(null);
	useEffect(() => {
		setSelectedMajor(
			getMajor?.filter(major => major?.ID === watch('major'))[0],
		);
	}, [watch('major')]);

	//getFamily
	const {
		data: { getFamily } = { getFamily: [] },
		called: familyCalled,
		loading: familyLoading,
	} = useGetFamilyQuery({
		fetchPolicy: 'network-only',
		variables: { majorID: selectedMajor?.ID },
	});

	//selectedFamily
	const [selectedFamily, setSelectedFamily] = useState(null);
	useEffect(() => {
		setSelectedFamily(
			getFamily?.filter(family => family?.ID === watch('family'))[0],
		);
	}, [watch('family')]);

	//getMealPeriod
	const {
		data: { getMealPeriod } = { getMealPeriod: [] },
		called: mealPeriodCalled,
		loading: mealPeriodLoading,
	} = useGetMealPeriodQuery({
		fetchPolicy: 'network-only',
		variables: { outletID: selectedOutlet?.ID },
	});

	//selectedMealPeriod
	const [selectedMealPeriod, setSelectedMealPeriod] = useState(null);
	useEffect(() => {
		setSelectedMealPeriod(
			getMealPeriod?.filter(
				mealPeriod => mealPeriod?.ID === watch('mealPeriod'),
			)[0],
		);
	}, [watch('mealPeriod')]);

	//slowMovingMenuItemAnalysis
	const [
		loadSlowMovingMenuItemAnalysis,
		{
			data: { slowMovingMenuItemAnalysis } = { slowMovingMenuItemAnalysis: [] },
			called: slowMovingMenuItemAnalysisCalled,
			loading: slowMovingMenuItemAnalysisLoading,
		},
	] = useGetSlowMovingMenuItemAnalysisLazyQuery({
		fetchPolicy: 'network-only',
	});

	//loadSlowMovingMenuItemAnalysis
	useEffect(() => {
		if (selectedOutlet && selectedStartDate && selectedEndDate) {
			loadSlowMovingMenuItemAnalysis({
				variables: {
					outletID: selectedOutlet?.ID,
					startDate: selectedStartDate,
					endDate: selectedEndDate,
					majorID: watch('major'),
					familyID: watch('family'),
					mealPeriodID: watch('mealPeriod'),
				},
			});
		}
	}, [
		selectedOutlet,
		selectedStartDate,
		selectedEndDate,
		selectedMajor,
		watch('major'),
		selectedFamily,
		watch('family'),
		selectedMealPeriod,
		watch('mealPeriod'),
	]);

	const [openShareDialog, setOpenShareDialog] = useState(false);
	const [openSendEmail, setOpenSendEmail] = useState(false);
	const [openPhoneNum, setOpenPhoneNum] = useState(false);
	const [email, setEmail] = useState('');
	const [openEmail, setOpenEmail] = useState(false);
	const [phoneNumber, setPhoneNumber] = useState('');
	const { snackFunc, snackBarMessage, openSnackBar } = useSnackBar();

	const [
		getShareAttachment,
		{
			data: { shareAttachment } = { shareAttachment: {} as any },
			called: shareAttachmentCalled,
			loading: shareAttachmentLoading,
		},
	] = useGetShareAttachmentMutation({
		onCompleted: () => {
			setOpenShareDialog(true);
		},
	});

	const onSubmit = blob => {
		getShareAttachment({
			variables: {
				file: blob,
				outletID: selectedOutlet?.ID,
			},
		});
	};

						const [ 
							createAttachment,
							{
								data: {  } = {
									createReceiptAttachment: {} as any,
								},
								called: createReceiptAttachmentCalled,
								loading: createReceiptAttachmentLoading,
							},
						] = useCreateReceiptAttachmentMutation({});
			
					const [
								EmailSend,
								{
									data: { emailSend } = { emailSend: {} as any },
									loading: loadingEmailSend,
								},
							] = useEmailSendMutation({});
			
									const ContentShare = () => (
							<div
								className="content-container"
								style={{
									position: 'fixed',
									top: '50%',
									left: '50%',
									transform: 'translate(-50%, -50%)',
								}}
							>
								<a target="_blank" rel="noopener noreferrer">
									<img
										src={shareAttachment?.fileURL}
										alt="Displayed Image"
										width="500px"
										height="500px"
									/>
								</a>
							</div>
						);
					
						const body = `Dear Customer,
					
					
					Please find the attached Slow Moving Menu Item Analysis. The details as follows:
					
					Outlet Name: ${selectedOutlet?.name}
					`;
					
						useEffect(() => {
							const QRContentString = ReactDOMServer.renderToStaticMarkup(ContentShare());
					
							openSendEmail &&
								EmailSend({
									variables: {
										body: {
											Header: `${selectedOutlet?.name} has shared you a file `,
											Body: body,
										},
										outletID: selectedOutlet?.ID,
										email:email,
										attachments: {
											filename: `Slow Moving Menu Item Analysis - ${selectedOutlet?.name}.jpg`,
											path: shareAttachment?.fileURL,
											cid: QRContentString,
										},
									},
								}).then(x => {
									if (x?.data?.emailSend === true) {
										snackFunc('Sent Email Successfully!', false);
										setOpenShareDialog(false);
									} else {
										snackFunc('Sent Email Fail!', false);
									}
								});
						}, [openSendEmail]);
					
							const shareReceiptRef = useRef(null);
							
								useEffect(() => {
									if (openShareDialog) {
										const timeoutId = setTimeout(() => {
											if (shareReceiptRef.current) {
												const attachment = shareReceiptRef.current;
							
												htmlToImage
													.toBlob(attachment, {
														style: { background: '#ffffff' },
														cacheBust: true,
													})
													.then(value => {
														onSubmit(value);
													})
													.catch(error => {
														console.error('Error generating image blob:', error);
													});
											} else {
												console.error('Element with id "share-receipt" not found.');
											}
										}, 100); // Delay execution to allow for rendering
							
										return () => clearTimeout(timeoutId); // Cleanup timeout on unmount
									}
								}, [openShareDialog]);

	return (
		<>
			<MainHeader
				onClick={() =>
					history.push({
						pathname: `/menu/outlet-app/business-insight/business-analytic`,
					})
				}
				mainBtn="back"
				smTitle="Business Insights"
				title={user?.companyName}
				routeSegments={[
					{ name: 'Business Insights' },
					{ name: 'Slow-Moving Menu Item Analysis', current: true },
				]}
			/>

			<DynamicSubHeader
				// style={{
				// 	width:
				// 		isDesktop && globalState.drawerOpen
				// 			? 'calc(100% - 288px)'
				// 			: isDesktop && !globalState.drawerOpen
				// 			? `calc(100% - 48px)`
				// 			: null,
				// }}
				title={
					getOutlet === undefined || getOutlet?.length === 0
						? ``
						: `${selectedOutlet?.name}`
				}
				handleClick={e => handleClick(e, null, 0)}
				dropDownOptions={
					<StyledMenu
						id="customized-menu"
						anchorEl={anchorEl}
						keepMounted
						open={Boolean(anchorEl)}
						onClose={handleClose}
						onClick={handleClose}
					>
						{getOutlet.map((outlet, index) => (
							<StyledMenuItem
								key={index}
								value={outlet.ID}
								defaultValue={outlet.ID}
								onClick={e => {
									setSelectedOutlet(outlet);
								}}
							>
								<ListItemText primary={outlet?.name} />
							</StyledMenuItem>
						))}
					</StyledMenu>
				}
			/>
			<ContentWrapper search footer>
				<CardActions style={{ paddingTop: '0px' }}>
					<MuiPickersUtilsProvider utils={DateFnsUtils}>
						<KeyboardDatePicker
							id="date-picker-dialog"
							style={{
								background: 'white',
								width: '50%',
								zIndex: 40,
							}}
							format="dd MMM yyyy"
							value={selectedStartDate}
							onChange={handleStartDateChange}
							KeyboardButtonProps={{
								'aria-label': 'change date',
							}}
							inputVariant="outlined"
							size="small"
							className="custom-date-business-insight"
						/>

						<KeyboardDatePicker
							id="date-picker-dialog"
							format="dd MMM yyyy"
							value={selectedEndDate}
							style={{
								background: 'white',
								width: '50%',
								zIndex: 40,
							}}
							onChange={handleEndDateChange}
							KeyboardButtonProps={{
								'aria-label': 'change date',
							}}
							inputVariant="outlined"
							size="small"
							className="custom-date-business-insight"
						/>
					</MuiPickersUtilsProvider>
				</CardActions>

				<CardActions>
					<Controller
						as={
							<TextField select variant="outlined" size="small" label="Major">
								{getMajor?.map((major, index) => (
									<MenuItem
										key={index}
										value={major.ID}
										defaultValue={major.ID}
									>
										{major.name}
									</MenuItem>
								))}
							</TextField>
						}
						// className="dropdown-bi"
						name={'major'}
						style={{
							marginTop: '0px',
							marginBottom: '0px',
							background: 'white',
							zIndex: 20,
						}}
						autoComplete="off"
						control={control}
						multiline
						fullWidth
						margin="normal"
					/>
					<Controller
						as={
							<TextField select variant="outlined" size="small" label="Family">
								{getFamily?.map((family, index) => (
									<MenuItem
										key={index}
										value={family.ID}
										defaultValue={family.ID}
									>
										{family.name}
									</MenuItem>
								))}
							</TextField>
						}
						name={'family'}
						disabled={!watch('major')}
						style={{
							marginTop: '0px',
							marginBottom: '0px',
							background: 'white',
							zIndex: 40,
						}}
						autoComplete="off"
						control={control}
						multiline
						fullWidth
						margin="normal"
					/>
					<Controller
						as={
							<TextField
								select
								variant="outlined"
								size="small"
								label="Meal Period"
							>
								{getMealPeriod?.map((mealPeriod, index) => (
									<MenuItem
										key={index}
										value={mealPeriod.ID}
										defaultValue={mealPeriod.ID}
									>
										{mealPeriod.name}
									</MenuItem>
								))}
							</TextField>
						}
						name="mealPeriod"
						style={{
							marginTop: '0px',
							marginBottom: '0px',
							background: 'white',
							zIndex: 40,
						}}
						autoComplete="off"
						control={control}
						multiline
						fullWidth
						margin="normal"
					/>
				</CardActions>

				{!slowMovingMenuItemAnalysisLoading &&
				(slowMovingMenuItemAnalysis === undefined ||
					slowMovingMenuItemAnalysis?.length === 0) ? (
					<EmptyList
						title={`No order item created for ${selectedOutlet?.name}`}
						subtitle="Please create new order to continue"
					/>
				) : (
					!slowMovingMenuItemAnalysisLoading && (
						<>
							{slowMovingAnalysisTable(
								slowMovingMenuItemAnalysis,
								selectedOutlet,
								selectedMajor,
								selectedFamily,
								selectedMealPeriod,
								selectedStartDate,
								selectedEndDate,
							)}
							{slowMovingAnalysisTable(
								slowMovingMenuItemAnalysis,
								selectedOutlet,
								selectedMajor,
								selectedFamily,
								selectedMealPeriod,
								selectedStartDate,
								selectedEndDate,
								true,
							)}
							<div className="cover-layer">
								<CardContents>
									<></>
								</CardContents>
							</div>
						</>
					)
				)}
			</ContentWrapper>

			{ShareDialog({
				shareTitle: `Slow Moving Menu Item Analysis - ${selectedOutlet?.name}`,
				title: `Share`,
				URL: shareAttachment?.fileURL,
				setSimple: setOpenShareDialog,
				simple: openShareDialog,
				emailShare:email,
				setSimpleEmail: setOpenSendEmail,
				isReceipt: true,
				phoneNumber: phoneNumber,
				setOpenPhoneNum: setOpenPhoneNum,
				setOpenEmail: setOpenEmail,
			})}

			<PhoneNumDialog
				open={openPhoneNum}
				setOpen={setOpenPhoneNum}
				shareTitle={`Slow Moving Menu Item Analysis - ${selectedOutlet?.name}`}
				URL={shareAttachment?.fileURL}
			/>

			<EmailDialog
				open={openEmail}
				setOpen={setOpenEmail}
				setSimpleEmail={setOpenSendEmail}
				setEmail={setEmail}
			/>
			<DynamicFooter
				overlap
				options={[
					// {
					// 	name: 'Share',
					// 	onClick: () => {
					// 		let temp = document.getElementById('hiddenTable');

					// 		htmlToImage
					// 			.toBlob(temp, { style: { background: '#fff' } })
					// 			.then(value => {
					// 				onSubmit(value);
					// 			});
					// 	},
					// 	disabled:
					// 		slowMovingMenuItemAnalysis == undefined ||
					// 		slowMovingMenuItemAnalysis.length == 0,
					// 	color: 'primary',
					// 	props: {
					// 		type: 'submit',
					// 	},
					// 	startIcon: <ShareIcon style={{ fontSize: '18px' }} />,
					// },
					{
						name: 'Share',
							onClick: () => {
								setOpenShareDialog(true);
							},
						disabled:
									slowMovingMenuItemAnalysis == undefined || slowMovingMenuItemAnalysis.length == 0,
						color: slowMovingMenuItemAnalysis == undefined ||	slowMovingMenuItemAnalysis.length == 0 
						? 'inherit' : 'primary',
						props: {
								type: 'submit',
							},
							startIcon: <ShareIcon style={{ fontSize: '18px' }} />,
					},
				]}
			/>
					<SnackBarMsg open={openSnackBar} message={snackBarMessage} />
		</>
	);
};

const slowMovingAnalysisTable = (
	slowMovingMenuItemAnalysis,
	selectedOutlet,
	selectedMajor,
	selectedFamily,
	selectedMealPeriod,
	selectedStartDate,
	selectedEndDate,
	hidden?: boolean,
) => {
	return (
		<div
			style={
				hidden
					? {
							zIndex: -40,
							top: 0,
							left: 0,
							position: 'fixed',
							width: '100%',
					  }
					: {
							marginTop: '0px',
							zIndex: 40,
							position: 'relative',
					  }
			}
			className={hidden ? 'hidden-content' : null}
		>
			<CardContents
				section={
					!hidden
						? {
								header: {
									title: 'Slow-Moving Menu Item Listing',
								},
						  }
						: null
				}
			>
				<TableContainer
					id={!hidden ? 'table' : 'hiddenTable'}
					style={{ overflow: 'hidden' }}
				>
					{hidden && (
						<div
							style={{
								textAlign: 'center',
								margin: '25px 0px 25px 0px',
							}}
						>
							<span
								style={{
									fontSize: '16px',
									fontWeight: 600,
									width: '180',
									whiteSpace: 'pre-line',
								}}
							>
								{`${selectedOutlet?.name} \n`}
							</span>
							<span
								style={{
									fontSize: '16px',
									fontWeight: 500,
									width: '180',
									whiteSpace: 'pre-line',
								}}
							>
								{`Slow Moving Analysis \n`}
							</span>
							<span
								style={{
									fontSize: '14px',
									fontWeight: 500,
									width: '180',
									whiteSpace: 'pre-line',
								}}
							>
								{`${formatDate(selectedStartDate.toISOString())} - ${formatDate(
									selectedEndDate.toISOString(),
								)} \n`}
							</span>

							<span
								style={{
									fontSize: '14px',
									fontWeight: 500,
									width: '180',
									whiteSpace: 'pre-line',
								}}
							>
								{selectedMajor && `${selectedMajor.name}`}
								{selectedFamily && `-${selectedFamily.name}`}
								{selectedMealPeriod && `(${selectedMealPeriod.name})`}
							</span>
						</div>
					)}

					<Table size="small" aria-label="a dense table">
						<TableHead>
							<TableRow
								style={{
									backgroundColor: '#8B92F9',
									color: 'white',
								}}
							>
								<TableCell
									align="center"
									style={{
										color: 'white',
										borderWidth: '2px',
										borderColor: 'white',
										borderStyle: 'solid',
										padding: '2px',
									}}
									component="td"
									width="40%"
								>
									Menu Item
								</TableCell>
								<TableCell
									align="center"
									style={{
										color: 'white',
										borderWidth: '2px',
										borderColor: 'white',
										borderStyle: 'solid',
										padding: '2px',
									}}
									component="td"
									width="30%"
								>
									Quantity
								</TableCell>
								<TableCell
									align="center"
									style={{
										color: 'white',
										borderWidth: '2px',
										borderColor: 'white',
										borderStyle: 'solid',
										padding: '2px',
									}}
									component="td"
									width="30%"
								>
									Sales Amt
								</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{slowMovingMenuItemAnalysis.map((el, index) => (
								<TableRow>
									<TableCell
										component="th"
										style={{
											backgroundColor: '#CADCFF',
											borderWidth: '2px',
											borderColor: 'white',
											borderStyle: 'solid',
											padding: '5px 15px 5px 15px',
										}}
									>
										{index + 1 + '.'}&nbsp;
										{el.name}
									</TableCell>
									<TableCell
										component="th"
										style={{
											backgroundColor: '#CADCFF',
											borderWidth: '2px',
											borderColor: 'white',
											borderStyle: 'solid',
											padding: '5px 15px 5px 15px',
										}}
									>
										{el.quantity}
									</TableCell>
									<TableCell
										component="th"
										style={{
											backgroundColor: '#CADCFF',
											color: '#ff9800',
											borderWidth: '2px',
											borderColor: 'white',
											borderStyle: 'solid',
											padding: '5px 15px 5px 15px',
										}}
									>
										{amtStr(el.amount)}
									</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
					<div style={{ paddingBottom: '10px' }}></div>
				</TableContainer>
			</CardContents>
		</div>
	);
};
